import React from "react";
import TitleHeader from "./Title_header";
import ButtonHeader from "./Btn_header";


const Header = ( {data} ) => {
    return(
        <header className="flex justify-between">
             <ButtonHeader data = {data}/>
             <TitleHeader data = {data}/> 
        </header>  
    );
};

export default Header;


